<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<router-outlet> </router-outlet>
<app-content-editor *ngIf="isAdmin"></app-content-editor>
